import { render } from "./cloudflare_image_lib.vue?vue&type=template&id=47521035&scoped=true"
import script from "./cloudflare_image_lib.vue?vue&type=script&lang=js"
export * from "./cloudflare_image_lib.vue?vue&type=script&lang=js"

import "./cloudflare_image_lib.vue?vue&type=style&index=0&id=47521035&lang=scss&scoped=true"

import exportComponent from "/root/buildarea/v8-production-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47521035"]])

export default __exports__